/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TwoFactorAuthenticationModule
 */
export interface TwoFactorAuthenticationModule {
    /**
     * 
     * @type {boolean}
     * @memberof TwoFactorAuthenticationModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the TwoFactorAuthenticationModule interface.
 */
export function instanceOfTwoFactorAuthenticationModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TwoFactorAuthenticationModuleFromJSON(json: any): TwoFactorAuthenticationModule {
    return TwoFactorAuthenticationModuleFromJSONTyped(json, false);
}

export function TwoFactorAuthenticationModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TwoFactorAuthenticationModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function TwoFactorAuthenticationModuleToJSON(value?: TwoFactorAuthenticationModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

